import { EventEmitter, Injectable } from "@angular/core";

import { ModalComponent } from "../../components/modal/modal.component";

@Injectable()
export class ModalService {
  private modals: ModalComponent[];
  modalClose = new EventEmitter<string>();

  constructor() {
    this.modals = [];
    console.error("ModalService is not implemented");
  }

  registerModal(_newModal: ModalComponent): void {
    // const modal = this.findModal(newModal.modalId);
    // if (modal) {
    //   this.modals.splice(this.modals.indexOf(modal));
    // }
    // this.modals.push(newModal);
  }

  open(_modalId: string): void {
    // const modal = this.findModal(modalId);
    // if (modal) {
    //   modal.isOpen = true;
    // }
  }

  close(_modalId: string): void {
    // const modal = this.findModal(modalId);
    // if (modal) {
    //   modal.isOpen = false;
    //   this.modalClose.emit(modalId);
    // }
  }

  private findModal(_modalId: string): ModalComponent | null {
    // for (const modal of this.modals) {
    //   if (modal.modalId === modalId) {
    //     return modal;
    //   }
    // }
    return null;
  }
}
